"use client"

import * as React from "react"
import { cn } from "../lib/utils"
import { SidebarHeader } from "./ui/sidebar"

interface SidebarToggleHeaderProps {
  isHistoryPage: boolean
  onToggle: () => void
  t: (key: string) => string
  isPending?: boolean
}

export const SidebarToggleHeader: React.FC<SidebarToggleHeaderProps> = ({
  isHistoryPage,
  onToggle,
  t,
  isPending = false,
}) => {
  const goActivos = () => { if (isHistoryPage) onToggle() }
  const goHistorial = () => { if (!isHistoryPage) onToggle() }

  return (
    <SidebarHeader className="p-2">
      <div className="grid grid-cols-2 gap-2 rounded-lg border border-[#E5E7EC] bg-white p-1">
        <button
          onClick={goActivos}
          disabled={isPending || !isHistoryPage}
          className={cn(
            "h-10 rounded-md text-sm font-medium transition text-[#252A32]",
            !isHistoryPage
              ? "bg-[#F6F7F9] shadow-sm border border-[#105BDB]"
              : "hover:bg-[#F6F7F9]",
            (isPending || !isHistoryPage) && "cursor-default"
          )}
        >
          {t("actives")}
        </button>
        <button
          onClick={goHistorial}
          disabled={isPending || isHistoryPage}
          className={cn(
            "h-10 rounded-md text-sm font-medium transition text-[#252A32]",
            isHistoryPage
              ? "bg-[#F6F7F9] shadow-sm border border-[#105BDB]"
              : "hover:bg-[#F6F7F9]",
            (isPending || isHistoryPage) && "cursor-default"
          )}
        >
          {t("history")}
        </button>
      </div>
    </SidebarHeader>
  )
}
